export const AUTHORIZATION_REQUIRED_RESPONSE_CODE = 401;

export const isAuthenticationError = (errorObj: { statusCode: number }) =>
  errorObj?.statusCode === AUTHORIZATION_REQUIRED_RESPONSE_CODE;
